import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { timezoneNames } from '@progress/kendo-date-math';
import '@progress/kendo-date-math/tz/America/Los_Angeles';
import '@progress/kendo-date-math/tz/America/New_York';
import '@progress/kendo-date-math/tz/Asia/Dubai';
import '@progress/kendo-date-math/tz/Asia/Tokyo';
import '@progress/kendo-date-math/tz/Etc/UTC';
import '@progress/kendo-date-math/tz/Europe/Madrid';
import '@progress/kendo-date-math/tz/Europe/Sofia';
import { guid } from '@progress/kendo-react-common';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import {
  IntlProvider,
  load,
  loadMessages,
  LocalizationProvider,
} from '@progress/kendo-react-intl';
import { Popup } from '@progress/kendo-react-popup';
import {
  AgendaView,
  DayView,
  MonthView,
  Scheduler,
  SchedulerEditItem,
  TimelineView,
  WeekView,
} from '@progress/kendo-react-scheduler';
import '@progress/kendo-theme-bootstrap/dist/all.css';
// import '@progress/kendo-theme-default/dist/all.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { FormWithCustomEditor } from './custom-form';
import { EditItemWithDynamicTitle } from './custom-item';
import esMessages from './es.json';
import {
  customData,
  customModelFields,
  displayDate,
  sampleData,
  sampleDataWithCustomSchema,
} from './events-utc';
import { updateApprovarContactUser, updateLocation, updateLocationDropdownsInMasterData, updateShift } from "../../JobOpportunity/action";
import useConfiguration from "../../../hooks/useConfiguration";
loadMessages(esMessages, 'es-ES');


function KendoScheduler({ multiShiftData, handleSave, startDate }) {
  const timezones = React.useMemo(() => timezoneNames(), []);
  const { editDayDate, masterData,shift,location } = useSelector(state => state.jobOpportunity);
  const config = useConfiguration();
  const dispatch = useDispatch()
  const locales = [
    {
      language: 'en-US',
      locale: 'en',
    },
    {
      language: 'es-ES',
      locale: 'es',
    },
  ];
  const [view, setView] = React.useState('month');
  const [date, setDate] = React.useState(
    startDate ? new Date(startDate) : new Date()
  );
  const [locale, setLocale] = React.useState(locales[0]);
  // const [timezone, setTimezone] = React.useState('Etc/UTC');
  // const [orientation, setOrientation] = React.useState('horizontal');
  const [data, setData] = React.useState(multiShiftData);
  const handleViewChange = React.useCallback(
    (event) => {
      setView(event.value);
    },
    [setView]
  );
  const handleDateChange = React.useCallback(
    (event) => {
      setDate(event.value);
    },
    [setDate]
  );
  const getNewlyCreatedOccurrence = element => {
    const calenderRequestBody = {
      ...element,
      TaskID: guid(),
      ownerID: guid(),
      Description: '',
      StartTimezone: null,
      EndTimezone: null,
      RecurrenceRule: null,
      RecurrenceID: 0,
      RecurrenceException: [],
      editDay: false,
      isAllDay:false,
    payRateOccurrenceAmount: null
    }
    console.log({calenderRequestBody});
    return calenderRequestBody;
  }
  // const handleLocaleChange = React.useCallback(
  //   (event) => {
  //     setLocale(event.target.value);
  //   },
  //   [setLocale]
  // );
  // const handleTimezoneChange = React.useCallback(
  //   (event) => {
  //     setTimezone(event.target.value);
  //   },
  //   [setTimezone]
  // );
  // const handleOrientationChange = React.useCallback((event) => {
  //   setOrientation(event.target.getAttribute('data-orientation'));
  // }, []);
  // const handleDataChange = React.useCallback(
  //   ({ created, updated, deleted }) => {
  //     setData((old) => {
  //       const newValue = old
  //         .filter(
  //           (item) =>
  //             deleted.find((current) => current.TaskID === item.TaskID) ===
  //             undefined
  //         )
  //         .map(
  //           (item) =>
  //             updated.find((current) => current.TaskID === item.TaskID) || item
  //         )
  //         .concat(
  //           created.map((item) =>
  //             Object.assign({}, item, {
  //               TaskID: guid(),
  //             })
  //           )
  //         );
  //       handleSave(newValue);
  //       return newValue;
  //     });
  //   },
  //   [setData]
  // );

  const filterDuplicate = (editDayDate,RecurrenceException) => {
    const filterData = editDayDate.map(day =>  new Date(day["ExceptionDate"])).filter(item => RecurrenceException.map(item => item.toString()).indexOf(item.toString())<0);
    return filterData
  }
  const generateCreatedList = (editDayDate,created, recurrenceExceptionList) => {
    const exceptionList = recurrenceExceptionList?.map(item => moment(item).format("YYYY-MM-DD"))
    const createdList = [];
    editDayDate.map((day,index) => {
      if(index===0){
        createdList.push(Object.assign({}, {...created[0],Start:new Date(day["Start"]),End:new Date(day["End"]),editDay:true,originalStart:new Date(day["Start"]),RecurrenceException:[]},{TaskID: guid(),})) 
      } else {
        if(exceptionList?.indexOf(moment(day?.Start)?.format("YYYY-MM-DD")) < 0){
          createdList.push(Object.assign({},{...created[0],Start:new Date(day["Start"]),End:new Date(day["End"]),editDay:true,originalStart:new Date(day["Start"]),RecurrenceException:[]},{TaskID: guid(),}
          )) 
        }
      }
      })
      return createdList
  }
  const generateUpdatedList = (editDayDate,created, recurrenceExceptionList) => {
    const updatedList = [];
    const exceptionList = recurrenceExceptionList?.map(item => moment(item).format("YYYY-MM-DD"))
    editDayDate?.map(day => {
      if(exceptionList?.indexOf(moment(day?.Start)?.format("YYYY-MM-DD")) < 0){
        updatedList.push(Object.assign({},{...created[0],Start:new Date(day["Start"]),End:new Date(day["End"]),editDay:true,originalStart:new Date(day["Start"]),RecurrenceException:[]},{TaskID: guid(),}
        )) 
      }
    })
    return updatedList
  }
  const handleDataChange = React.useCallback(
    ({ created, updated, deleted }) => {
      if(updated.length && updated?.[0]?.RecurrenceRule){
        if(location?.locationNameInfo?.id !== updated?.[0]?.locationId){
          const updatedLocation = masterData?.allJobLocations?.find(item => item?.id ===  updated?.[0]?.locationId)
          dispatch(updateLocation("locationNameInfo", updatedLocation));
          dispatch(updateLocationDropdownsInMasterData(`${config.baseUrl}`,updated?.[0]?.locationId)).then(response =>  {
            if(response){
              dispatch(updateApprovarContactUser({field:"approvalUsers",response:response?.approversForLocation ? response?.approversForLocation : [], userList:updated?.[0]?.jobsApproversList ? updated?.[0]?.jobsApproversList : []}))
              dispatch(updateApprovarContactUser({field:"contactPersons",response:response?.contactsForLocation ? response?.contactsForLocation: [], userList:updated?.[0]?.jobsContactsList ? updated?.[0]?.jobsContactsList: []}))
            }
          })
        }
        if(shift?.startTime?.name !== moment(updated?.[0]?.Start).format("hh:mm A") || shift?.endTime?.name !== moment(updated?.[0]?.End).format("hh:mm A")){
          const updatedShiftStartTime = masterData?.allShiftStartTime?.find(item => item?.name === moment(updated?.[0]?.Start).format("hh:mm A"))
          const updatedShiftEndTime = masterData?.allShiftEndTime?.find(item => item?.name === moment(updated?.[0]?.End).format("hh:mm A"))
          dispatch(updateShift("startTime", updatedShiftStartTime))
          dispatch(updateShift("endTime", updatedShiftEndTime))
        }
      }
      setData((old) => {
       let newValue;
       if(created?.[0]?.editDay ||(updated?.[0]?.editDay && ! updated?.[0]?.RecurrenceRule )){
        const updatedFilterList =  old.map(item => {
          return updated.find((current) => current.TaskID === item.TaskID) || item
        })
        const list =  created?.[0]?.editDay ? generateCreatedList(editDayDate,created,updatedFilterList?.[0]?.RecurrenceException) : updated?.[0]?.editDay ? generateUpdatedList(editDayDate,updated,updatedFilterList?.[0]?.RecurrenceException):[]
        newValue = updatedFilterList?.map((item,index,arr) => {
          if(index === 0){
            const {RecurrenceException,...rest} = item;
            return {RecurrenceException:RecurrenceException.concat(filterDuplicate(editDayDate,RecurrenceException)),...rest} 
          }
        const filterValue = editDayDate?.map(item => moment(item?.Start).format("YYYY-MM-DD")).findIndex(date => date === moment(item?.Start).format("YYYY-MM-DD"))
        if( filterValue > -1){
          return {...item,editDay:true,Start:new Date(editDayDate[filterValue]?.Start),End:new Date(editDayDate[filterValue]?.End)}
        }
        else if (filterValue === -1){
          return item
        }
        if(!updated[0]?.editDay){
            return item
          }
        })
        .concat(list)
       }
       else{
        newValue = old.filter((item) => deleted.find((current) => current.TaskID === item.TaskID) === undefined)
        .map((item) =>updated.find((current) => current.TaskID === item.TaskID) || item)
        .concat(created.map((item) => {
          console.log({item});
          if(item?.ownerID){
            return Object.assign({},item,{TaskID: guid(),})
          } else {
            return getNewlyCreatedOccurrence(item)
          }
        }
          )
        );
       }
        handleSave(newValue);
        return newValue;
      });
    },
    [setData,editDayDate]
  );
  return (
    <div>
      {/* <div className="example-config">
        <div className="row">
          <div className="col">
            <h5>Timezone:</h5>
            <DropDownList
              value={timezone}
              onChange={handleTimezoneChange}
              data={timezones}
            />
          </div>
          <div className="col">
            <h5>Locale:</h5>
            <DropDownList
              value={locale}
              onChange={handleLocaleChange}
              data={locales}
              textField="language"
              dataItemKey="locale"
            />
          </div>
          <div className="col">
            <h5>Orientation:</h5>
            <input
              type="radio"
              name="orientation"
              id="horizontal"
              data-orientation="horizontal"
              className="k-radio k-radio-md"
              checked={orientation === 'horizontal'}
              onChange={handleOrientationChange}
            />
            <label className="k-radio-label" htmlFor="horizontal">
              Horizontal
            </label>
            <br />
            <input
              type="radio"
              name="orientation"
              id="vertical"
              data-orientation="vertical"
              className="k-radio k-radio-md"
              checked={orientation === 'vertical'}
              onChange={handleOrientationChange}
            />
            <label className="k-radio-label" htmlFor="vertical">
              Vertical
            </label>
          </div>
        </div>
      </div> */}
      <LocalizationProvider language={locale.language}>
        <IntlProvider locale={locale.locale}>
          <Scheduler
            data={data}
            onDataChange={handleDataChange}
            view={view}
            onViewChange={handleViewChange}
            date={date}
            onDateChange={handleDateChange}
            editable={true}
            modelFields={customModelFields}
            // editItem={EditItemWithDynamicTitle}
            form={FormWithCustomEditor}
            // timezone={timezone}
            // editItem={CustomEditItem}
            // group={{
            //   orientation,
            // }}
          >
            {/* <TimelineView /> */}
            <DayView showWorkHours={false} />
            <WeekView showWorkHours={false} />
            <MonthView />
            {/* <AgendaView /> */}
          </Scheduler>
        </IntlProvider>
      </LocalizationProvider>
    </div>
  );
}

export default KendoScheduler;
